// extracted by mini-css-extract-plugin
module.exports = {"flex-center":"_3jffD2lfJrQ7mHEEe740oe","titleMessage":"_1lfzzN12dsGFRvMaa0Wyzb","wrapper":"_2PW4kYwQ9_A6JPbAz1KXE9","textContent":"_1OtTSMinJ0fEQzVmMx797C"};